import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { markAppReload } from '~/lib/reloadDiagnostics';
import { attemptRecovery } from '~/lib/recoveryGuard';
import { NotFound } from '~/ui/not-found/NotFound';
import { useTrainingParams } from '../useTrainingParams';
import { useTrainingUrl } from '../useTrainingUrl';

/**
 * A slide link can outlive the slide: a publish moves learners to a new
 * version of the course, and an edit can delete a slide, so a refresh or a
 * bookmark may name a slide that is no longer in their course. Send them back
 * to where they left off instead, once; if that keeps landing here, show the
 * lost page rather than redirecting in a loop.
 */
export const UnknownSequence = () => {
  const trainingUrl = useTrainingUrl();
  const { learnerTrainingId, sequenceId } = useTrainingParams();
  const [recovering] = useState(() => {
    if (!trainingUrl) return false;
    if (
      attemptRecovery(
        'unknown-slide-redirect',
        `${learnerTrainingId}.${sequenceId}`
      )
    )
      return true;

    markAppReload('unknown-slide-recovery-stopped', {
      learnerTrainingId,
      sequenceId
    });
    return false;
  });

  if (!trainingUrl || !recovering) return <NotFound />;

  return <Redirect to={trainingUrl} />;
};
